/* eslint-disable local-rules/scoped-modules */
import type { StorageType } from './type';
import { WebStorage } from './WebStorage';

export { WebStorage } from './WebStorage';

export const localStorage = new WebStorage<StorageType>();

export const sessionStorage = new WebStorage<StorageType>({
  type: 'sessionStorage',
});

export * from './type';

export * from './LRULocalStorage';
